import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-body";

const keys = addTranslations(RESOURCE_NAME, {
    questionnaires: {
        en: "Questionnaires",
        fr: "Questionnaires",
    },
    users: {
        en: "Users",
        fr: "Utilisateurs",
    },
    add_user: {
        en: "Add user",
        fr: "Ajouter un utilisateur",
    },
    send_new_questionnaire_button: {
        en: "Assign questionnaire",
        fr: "Attribuer un questionnaire",
    },
    send_new_questionnaire_tooltip: {
        en: "This supplier has an open questionnaire. Close it before sending a new one.",
        fr: "Ce fournisseur a un questionnaire ouvert. Fermez-le avant d'envoyer un nouveau questionnaire.",
    },
    send_reminder_button: {
        en: "Notify by email",
        fr: "Notification par email",
    },
    open_questionnaire_error_message: {
        en: "An error occurred while opening the questionnaire",
        fr: "Une erreur est survenue lors de l'ouverture du questionnaire",
    },
    open_questionnaire_success_message: {
        en: "Questionnaire opened successfully",
        fr: "Questionnaire ouvert avec succès",
    },
    send_email_error_message: {
        en: "An error occurred while sending the email",
        fr: "Une erreur est survenue lors de l'envoi de l'email",
    },
    send_email_success_message: {
        en: "Email sent successfully",
        fr: "Email envoyé avec succès",
    },
});

export function useSupplierBodyTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
